/// <amd-module name="Feed/Legacy/Components/WrappedZeroFeedsPage" />
import * as React from "react";

import { WrappedComponent } from "VSS/Platform/Layout";

export function WrappedZeroFeedsPage() {
    return (
        <WrappedComponent dependencies={["ms.feed.feed-createfeed"]} wrappedType="ms.feed.feed-createfeed.zerofeeds" />
    );
}
